import { render, staticRenderFns } from "./TrackTitleAndScore.vue?vue&type=template&id=0af1edf6&scoped=true&"
import script from "./TrackTitleAndScore.vue?vue&type=script&lang=js&"
export * from "./TrackTitleAndScore.vue?vue&type=script&lang=js&"
import style0 from "./TrackTitleAndScore.vue?vue&type=style&index=0&id=0af1edf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af1edf6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
